export enum CheckingStatuses {
    NoStatus = 0,
    ReadyToCheck = 1,
    Adopted = 2,
    CheckFailed = 3,
    Draft = 4
}

export var CheckingStatusesDescription: { [key: CheckingStatuses]: string; } = {};
CheckingStatusesDescription[CheckingStatuses.NoStatus] = "��� �������";
CheckingStatusesDescription[CheckingStatuses.ReadyToCheck] = '����������� � ��������';
CheckingStatusesDescription[CheckingStatuses.Adopted] = '������';
CheckingStatusesDescription[CheckingStatuses.CheckFailed] = '�� ������ ��������';
CheckingStatusesDescription[CheckingStatuses.Draft] = '��������';